module.exports = __webpack_public_path__ + "img/paypal.1c223287.svg";